import logger from '@/commons/logger';
import {err} from '@/commons/toast';
import {HttpError} from '@/store/models';
import {i18n} from '@/i18n';
import {isString, isArray} from 'lodash';
import app from '@/store/modules/app';

export default (e: any, dolog = true) => {
    let toLogErr;
    let message = '';

    if (e.isAxiosError) {
        const typedErr: HttpError = e;

        if (typedErr.response.status === 500) {
            message = i18n.t('Service unavailable, retry later').toString();
        } else if (typedErr.response.status === 403) {
            message = i18n.t('Error, try to logout and login back to proceed with checkout').toString();
        } else {
            message = i18n.t(typedErr.response.data.message).toString();
        }

        if (typedErr.response.data.parameters && isArray(typedErr.response.data.parameters)) {
            let i = 1;

            typedErr.response.data.parameters.forEach((errParam) => {
                message = message.replace(`%${i}`, errParam);
                i += 1;
            });
        }

        if (app.isApp) {
            const messageData = {
                type: 'error',
                text: message,
            };
            app.displayMessage(messageData);
        } else {
            err(message);
        }
        toLogErr = {
            url: typedErr.config.url,
            code: typedErr.response.status,
            errmess: message,
            payload: typedErr.config.data,
        };
    } else {
        toLogErr = isString(e) ? e : e.toString();
    }

    if (dolog) {
        logger.error(toLogErr);
    }

    return {message};
};
